import _mapValues from "lodash/mapValues";
import _isPlainObject from "lodash/isPlainObject";
const parseErrorJson = (msgs = []) => msgs.map(message => {
  if (message.match(/^\{/)) {
    return JSON.parse(message);
  }
  return message;
});
/**
 *
 * rawFieldErrorMap might look like
 ``` js
  {
    "name": "setting.some.error.locale.key",  // string case
    "address": [  // array case
      "setting.foo.error.locale.key",
      "setting.bar.message.locale.key",
    ],
    "group": {  // subfield case
      "subfield": "setting.some.error.locale.key",
    },
    tel: "\{"key":"setting.some.error.locale.key","params":{"foo":"foo"}}"  // JSON string case
  }
 ```
 */
const traverseAndParseErrorJson = rawFieldErrorMap => _mapValues(rawFieldErrorMap, rawFieldError => {
  // is sub-field
  if (_isPlainObject(rawFieldError)) {
    return traverseAndParseErrorJson(rawFieldError);
  }

  // is messages list of a Field
  if (Array.isArray(rawFieldError)) {
    return parseErrorJson(rawFieldError);
  }

  // else it's a message string
  return parseErrorJson([rawFieldError]);
});
export default traverseAndParseErrorJson;